import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import * as Yup from "yup";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { useDispatch, useSelector } from "react-redux";
import {
  loadCampaignEditPage,
  unloadCampaignDetailPage,
  updateCampaign
} from "../../redux/actions/asset.actions";
import ListErrors from "../../components/ListErrors";
import Nav from "../../components/Nav";
import Header from "../../components/Header";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import moment from "moment";
import { Translation } from "react-i18next";
import i18n from "../../languages/lang.js";

const CampaignSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, i18n.t("campaign.form_name_invalid_error"))
    .required(i18n.t("campaign.form_name_required_error")),
  site: Yup.string().required(i18n.t("campaign.form_site_required_error"))
});

export default () => {
  let { key } = useParams();
  const dispatch = useDispatch();
  const [dates, setDateRange] = useState(null);
  const asset = useSelector(state => state.asset);
  useEffect(() => {
    dispatch(loadCampaignEditPage(key));
    return () => dispatch(unloadCampaignDetailPage());
  }, [key]);

  useEffect(() => {
    if (asset.campaign) {
      setDateRange([
        moment(asset.campaign.start_date).toDate(),
        moment(asset.campaign.end_date).toDate()
      ]);
    }
  }, [asset.campaign]);

  const handleSubmit = (name, notes, site, start_date, end_date) =>
    dispatch(updateCampaign(key, name, notes, site, start_date, end_date));

  if (!asset.sites || !asset.campaign) {
    return (
      <Translation>
        {t => (
          <div id="main">
            <Nav selected={"campaigns"} />
            <div id="content">
              <Header />
              <div id="loading">{t("system.loading")}</div>
            </div>
          </div>
        )}
      </Translation>
    );
  }

  const campaign = asset.campaign;
  // useEffect(() => {
  //     setDateRange([campaign.start_date, campaign.end_date])
  // })
  return (
    <Translation>
      {t => (
        <div id="main">
          <Nav selected={"campaigns"} />
          <div id="content">
            <Header />
            <div className="content-wrap content-narrow">
              <div className="box-header">
                <Link
                  className="header-button"
                  to={`/campaigns/${campaign.key}`}
                >
                  {t("common.back")}
                </Link>
                <h2>{t("campaign.update_title")}</h2>
              </div>
              <Formik
                initialValues={{
                  name: campaign.name,
                  notes: campaign.notes,
                  site: campaign.site
                }}
                validationSchema={CampaignSchema}
                onSubmit={(payload, { setSubmitting }) => {
                  handleSubmit(
                    payload.name,
                    payload.notes,
                    payload.site,
                    dates[0],
                    dates[1]
                  );
                  setSubmitting(false);
                }}
              >
                {({ isSubmitting }) => (
                  <Form>
                    <div className={`form-item`}>
                      <label htmlFor="name">{t("common.site")}</label>
                      <Field as="select" name="site">
                        <option key={""} value={""}>
                          {t("common.option_select_site")}
                        </option>
                        {asset.sites.map(item => {
                          return (
                            <option key={item.key} value={item.key}>
                              {item.name}
                            </option>
                          );
                        })}
                      </Field>
                      <ErrorMessage
                        name="site"
                        className="error-message"
                        component="div"
                      />
                    </div>
                    <div className={`form-item`}>
                      <label htmlFor="name">{t("campaign.label_name")}</label>
                      <Field type="text" name="name" />
                      <ErrorMessage
                        name="name"
                        className="error-message"
                        component="div"
                      />
                    </div>
                    <div className={`form-item`}>
                      <label htmlFor="notes">{t("campaign.label_dates")}</label>
                      <DateRangePicker
                        onChange={dates => setDateRange(dates)}
                        value={dates}
                      />
                    </div>
                    <div className={`form-item`}>
                      <label htmlFor="notes">
                        {t("campaign.label_sms_message")}
                      </label>
                      <Field component="textarea" name="notes" />
                    </div>
                    <ListErrors errors={asset.errors} />
                    <div className="form-item">
                      <button type="submit" disabled={isSubmitting}>
                        {isSubmitting
                          ? t("system.submitting_feeback")
                          : t("system.update_button")}
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      )}
    </Translation>
  );
};
